import Swiper from 'swiper';
import { gsap } from 'gsap';

//モジュールのインポート
import {
  Mousewheel,
  EffectFade,
  Autoplay,
} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

//トップページ
export function homeFunc() {
  document.body.classList.add('home');

  /* -------------------------------------------------
  // スライド切り替えに関する設定
  ---------------------------------------------------- */

  // スクロール終了検知の共通関数
  // function setupScrollHandler(element, swiperInstance, config) {
  //   if (element.hasScrollListener) return;

  //   let scrollTimeout;
  //   let isScrolling = false;
  //   let hasReachedEdge = false;
  //   let hasTriggered = false;

  //   const scrollHandler = function () {
  //     isScrolling = true;
  //     clearTimeout(scrollTimeout);

  //     const { scrollTop, scrollHeight, clientHeight } = this;
  //     const isAtEdge = config.checkEdge(scrollTop, scrollHeight, clientHeight);

  //     if (isAtEdge) {
  //       hasReachedEdge = true;
  //     } else {
  //       hasReachedEdge = false;
  //       hasTriggered = false;
  //     }

  //     scrollTimeout = setTimeout(() => {
  //       isScrolling = false;

  //       // スクロール停止時に、再度端に到達しているかどうかを確認
  //       const currentScrollTop = element.scrollTop;
  //       const currentScrollHeight = element.scrollHeight;
  //       const currentClientHeight = element.clientHeight;
  //       const isStillAtEdge = config.checkEdge(currentScrollTop, currentScrollHeight, currentClientHeight);

  //       // スクロールが停止し、端に到達している場合のみ切り替えを実行
  //       if (isStillAtEdge && hasReachedEdge && !hasTriggered && swiperInstance) {
  //         hasTriggered = true;
  //         hasReachedEdge = false;
  //         config.onReachEdge(swiperInstance);
  //       }
  //     }, 100);
  //   };

  //   element.addEventListener('scroll', scrollHandler);
  //   element.hasScrollListener = true;
  //   element.swiper = swiperInstance;
  // }

  // スクロールハンドラーの設定と1pxスクロール処理の共通関数
  // function setupScrollHandlerAndOffset(swiperInstance) {
  //   const currentSlide = swiperInstance.slides[swiperInstance.activeIndex];
  //   const homeScrollElement = currentSlide.querySelector('.p-home__scroll');
  //   const homeScrollElement02 = currentSlide.querySelector('.p-home__scroll__02');

  //   if (homeScrollElement) {
  //     swiperInstance.mousewheel.disable();
  //     setupScrollHandler(homeScrollElement, swiperInstance, {
  //       checkEdge: (scrollTop, scrollHeight, clientHeight) =>
  //         scrollTop + clientHeight >= scrollHeight,
  //       onReachEdge: (swiper) => {
  //         swiper.mousewheel.enable();
  //         swiper.slideNext();
  //       },
  //     });
  //     // スライド直後のスクロールの切り替えを可能にするため
  //     const { scrollTop, scrollHeight, clientHeight } = homeScrollElement;
  //     if (scrollTop + clientHeight >= scrollHeight) {
  //       homeScrollElement.scrollTop = Math.max(0, scrollTop - 1);
  //     }
  //   } else if (homeScrollElement02) {
  //     swiperInstance.mousewheel.disable();
  //     setupScrollHandler(homeScrollElement02, swiperInstance, {
  //       checkEdge: (scrollTop) => scrollTop <= 0,
  //       onReachEdge: (swiper) => swiper.slidePrev(),
  //     });
  //     // スライド直後のスクロールの切り替えを可能にするため
  //     const { scrollTop, scrollHeight, clientHeight } = homeScrollElement02;
  //     if (scrollTop <= 0) {
  //       const maxScrollTop = scrollHeight - clientHeight;
  //       homeScrollElement02.scrollTop = Math.min(maxScrollTop, scrollTop + 1);
  //     }
  //   } else {
  //     swiperInstance.mousewheel.enable();
  //   }
  // }

  // const swiper = new Swiper('.swiper-switch', {
  //   modules: [Mousewheel],
  //   direction: 'vertical',
  //   mousewheel: {
  //     sensitivity: 20,
  //     releaseOnEdges: true,
  //     forceToAxis: true,
  //     thresholdDelta: 5,
  //     thresholdTime: 20,
  //     enabled: false,
  //   },
  //   speed: 800,
  //   allowTouchMove: false,
  //   preventInteractionOnTransition: true,
  //   resistanceRatio: 0,
  //   on: {
  //     slideChange: function () {
  //       setupScrollHandlerAndOffset(this);
  //     },
  //     init: function () {
  //       setupScrollHandlerAndOffset(this);
  //     },
  //   },
  // });


  /* -------------------------------------------------
  // 画像のスライド切り替え設定
  ---------------------------------------------------- */
  // news-swiperの初期化
  initNewsSwiper();

  // news-swiperの初期化関数
  function initNewsSwiper() {
    const newsSwiper = new Swiper('.news-swiper', {
      modules: [EffectFade, Autoplay],
      effect: 'fade',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 1000,
      loop: true,
      allowTouchMove: true,
      slidesPerView: 1,
      spaceBetween: 0,
    });
  }

  /* -------------------------------------------------
  // FVのアニメーション設定
  ---------------------------------------------------- */

  // フェードインアニメーションの初期化
  initFadeAnimation();

  // フェードインアニメーション関数
  function initFadeAnimation() {
    let animationTriggered = false;

    function triggerAnimation() {
      if (animationTriggered) return;
      animationTriggered = true;

      // 背景動画の読み込みを待つため、少し遅らせる
      setTimeout(() => {
        startFadeAnimation();
      }, 100);
    }

    // 複数のイベントでアニメーションを開始
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', triggerAnimation);
    } else {
      triggerAnimation();
    }

    // 念のためloadイベントも追加
    window.addEventListener('load', triggerAnimation);
  }

  // js-fade-01のアニメーション関数
  function animateFade01(tl) {
    const fade01Element = document.querySelector('.js-fade-01');
    if (fade01Element) {
      tl.to(
        fade01Element,
        {
          duration: 0.5,
          ease: 'linear',
          onComplete: function () {
            fade01Element.classList.add('fade-01-animation');
          },
        },
        0
      );
    }
  }

  // js-fade-02のアニメーション関数
  function animateFade02(tl) {
    const fade02Elements = document.querySelectorAll('.js-fade-02');
    const fadeElements = Array.from(fade02Elements);

    if (fadeElements.length > 0) {
      tl.to(
        fadeElements,
        {
          duration: 1,
          ease: 'linear',
          stagger: 0.1, // 0.1秒ずつずらして表示
          onComplete: function () {
            // アニメーション完了時にis-fade-inクラスを追加
            fadeElements.forEach((element) => {
              element.classList.add('is-fade-in');
              // ランダム表示アニメーションを実行
              startRandomTextAnimation(element);
            });
          },
        },
        1
      ); // js-fade-01の完了後に開始（1秒後）
    }
  }

  // js-fade-03のアニメーション関数（スクロール監視）
  function animateFade03(tl) {
    const fade03Elements = document.querySelectorAll('.js-fade-03');

    if (fade03Elements.length > 0) {
      // SPかどうかを判定
      const isSP = window.innerWidth <= 768;

      if (isSP) {
        // SPの場合はタイムラインに組み込んで順番に実行
        tl.to(
          fade03Elements,
          {
            duration: 0.1,
            onComplete: function () {
              fade03Elements.forEach((element) => {
                element.classList.add('is-fade-in');
                startRandomTextAnimation(element);
              });
            },
          },
          2
        ); // js-fade-02の1秒後

        // SPの場合はanimateFade05をスクロール監視に変更
        const fade05Elements = document.querySelectorAll('.js-fade-05, .js-fade-05-bg');
        if (fade05Elements.length > 0) {
          const observerOptions = {
            root: null,
            rootMargin: '0px 0px -10% 0px',
            threshold: 0.1,
          };

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const element = entry.target;
                element.classList.add('is-fade-in');
                observer.unobserve(element);
              }
            });
          }, observerOptions);

          fade05Elements.forEach((element) => {
            observer.observe(element);
          });
        }
      } else {
        // PCの場合はタイムラインに組み込んで順番に実行
        const fadeElements = Array.from(fade03Elements);
        
        if (fadeElements.length > 0) {
          tl.to(
            fadeElements,
            {
              duration: 1,
              ease: 'linear',
              stagger: 0.1, // 0.1秒ずつずらして表示
              onComplete: function () {
                // アニメーション完了時にis-fade-inクラスを追加
                fadeElements.forEach((element) => {
                  element.classList.add('is-fade-in');
                  // ランダム表示アニメーションを実行
                  startRandomTextAnimation(element);
                });

                // js-fade-03要素が始まったらanimateFade05を実行
                setTimeout(() => {
                  animateFade05();
                }, 2000); // 2秒後にanimateFade05を実行
              },
            },
            3
          ); // js-fade-02の完了後に開始（2秒後）
        }
      }
    }
  }

  // js-fade-04のアニメーション関数
  function animateFade04(tl) {
    const fade04Elements = document.querySelectorAll(
      '.js-fade-04, .js-fade-04-2, .js-fade-04-bg'
    );

    if (fade04Elements.length > 0) {
      // タイムラインにアニメーションを追加
      tl.to(
        fade04Elements,
        {
          onComplete: function () {
            // アニメーション完了時にis-fade-inクラスを追加
            fade04Elements.forEach((element) => {
              element.classList.add('is-fade-in');
            });
          },
        },
        3
      ); // js-fade-03の1秒後
    }
  }

  // js-fade-05のアニメーション関数
  function animateFade05() {
    const fade05Elements = document.querySelectorAll(
      '.js-fade-05, .js-fade-05-bg'
    );

    if (fade05Elements.length > 0) {
      // is-fade-inクラスを追加
      fade05Elements.forEach((element) => {
        element.classList.add('is-fade-in');
      });
    }
  }

  // js-fade-06のアニメーション関数（スクロール監視）
  function animateFade06(tl) {
    const fade06Elements = document.querySelectorAll('.js-fade-06');

    if (fade06Elements.length > 0) {
      // Intersection Observerの設定
      const observerOptions = {
        root: null,
        rootMargin: '0px 0px -20% 0px',
        threshold: 0.1,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target;

            // is-fade-inクラスを追加
            element.classList.add('is-fade-in');

            // 監視を停止
            observer.unobserve(element);
          }
        });
      }, observerOptions);

      // js-fade-06要素を監視
      fade06Elements.forEach((element) => {
        observer.observe(element);
      });
    }
  }

  // 1文字ずつspanタグで囲う関数
  const wrapCharactersWithSpan = (element, className = '') => {
    const text = element.textContent.trim();
    const characters = text.split('');
    let wrappedContent = '';

    characters.forEach((char, index) => {
      if (char === ' ') {
        wrappedContent += '<span aria-hidden="true">&nbsp;</span>';
      } else if (char === '\n') {
        wrappedContent += '<br>';
      } else {
        wrappedContent += `<span class="${className}" aria-hidden="true" translate="no" style="--index: ${index};">${char}</span>`;
      }
    });

    element.innerHTML = wrappedContent;
  };

  // ランダム表示のテキストアニメーション関数
  const startRandomTextAnimation = (element) => {
    // 1文字ずつspanタグで囲う
    wrapCharactersWithSpan(element, 'char-span');

    // アニメーション対象のspan要素を取得
    const fadeInChars = element.querySelectorAll('span.char-span');
    const spansArray = Array.from(fadeInChars);

    // ランダムに要素を選択してアクティブ化する関数
    const addActiveClassRandomly = () => {
      if (spansArray.length === 0) return;

      const randomIndex = Math.floor(Math.random() * spansArray.length);
      const randomSpan = spansArray[randomIndex];

      randomSpan.classList.add('is-active');
      spansArray.splice(randomIndex, 1);

      if (spansArray.length > 0) {
        setTimeout(addActiveClassRandomly, 5);
      }
    };
    addActiveClassRandomly();
  };

  // 各アニメーション関数を実行
  function startFadeAnimation() {
    const tl = gsap.timeline();

    animateFade01(tl);
    animateFade02(tl);
    animateFade03(tl);
    animateFade04(tl);
    // animateFade05はanimateFade03完了後に実行される
    animateFade06(tl);
  }
}

